var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lw-use-guide"},[_vm._v(" lw-use-guide "),_c('span',{staticClass:"close-use-guide",on:{"click":_vm.closeUseGuide}},[_vm._v("收起")])])
}
var staticRenderFns = []

export { render, staticRenderFns }